define(
    'views/mentions.view',[
        'loader',
        'config',
        'helper',
        'sandbox'
    ],
    function(Loader, Config, Helper, Sandbox)
    {
        var $ = Loader.$;
        var _ = Loader._;

        var MentionsView = Loader.Backbone.View.extend(
            {
                nicks: [],

                events: {
                    'click .post .post-author ul li.pa-author a': 'rememberLogin',
                    'click .post .pl-quote a': 'rememberLoginFromQuotes',
                    'click #post input[name="submit"]:first': 'saveNicknames'
                },

                routes: {
                    "/viewtopic.php[?]id=(.*)(&p=[\d]+)?#p(.*)": "checkNames",
                    "/viewtopic.php[?]id=(.*)": "markMessagesAsRead",
                    "/messages.php$": "checkPMNames",
                    "/messages.php#post$": "checkPMNames",
                    "*": "cleanNames"
                },

                initialize: function()
                {
                    var _this = this;
                    _.bindAll(this, 'render');

                    this.model.on('startApplication', function(){
                        Helper.filterRoutes(_this.routes, _this);
                    });
                },

                render: function()
                {
                    return this;
                },

                rememberLogin: function(e)
                {
                    var nick = $(e.currentTarget).text();
                    this.nicks.push(nick);
                },

                rememberLoginFromQuotes: function(e)
                {
                    var elem = $(e.currentTarget).attr('href');
                    var matches = /javascript:quote\('(.*)', (\d+)\)/.exec(elem);

                    if (matches && matches[1]) {
                        return this.nicks.push(matches[1]);
                    }

                    if (elem.indexOf('changeVisibility(') !== -1) {
                        var nickname = $('form#post input[name=req_username]').val();
                        if (nickname) {
                            this.nicks.push(nickname);
                        }
                    }
                },

                saveNicknames: function(e)
                {
                    var href = document.location.href;
                    var nickname = $('form#post input[name=req_username]').val();

                    if (href.indexOf('viewtopic.php?')!=-1)
                    {
                        Sandbox.storage.set('mentionsLogins', this.nicks);
                    }
                    else if (href.indexOf('messages.php?action=new')!=-1 || href.indexOf('messages.php?box=')!=-1)
                    {
                        if (nickname) {
                            this.nicks.push(nickname);
                            Sandbox.storage.set('mentionsLogins', this.nicks);
                        }
                    }
                },

                checkNames: function(e)
                {
                    var names = Sandbox.storage.get('mentionsLogins');
                    if (!names) return;

                    var postId = document.location.hash.replace('#p', '');

                    var $post = $('#p'+ postId +'-content').html();
                    var mentions = [];

                    names.forEach(function(name){
                        if ($post.indexOf('<strong>'+ name +'</strong>') != -1) {
                            mentions.push(name);
                        }
                        else if ($post.indexOf('<cite>'+ name +' написал(а):</cite>') != -1) {
                            mentions.push(name);
                        }
                    });

                    mentions = _.unique(mentions);

                    Sandbox.transport.io.send('mentions', {
                        users: mentions,
                        postId: postId,
                        topicName: FORUM.get('topic.subject'),
                        topicId: Helper.getParam('id')
                    });
                },

                checkPMNames: function(e)
                {
                    var names = Sandbox.storage.get('mentionsLogins');
                    if (!names) return;
                    names = _.unique(names);
                    if (names.length != 1) return;

                    Sandbox.transport.io.send('pmNotification', {
                        user: names[0]
                    });

                },

                cleanNames: function(e)
                {
                    if (document.location.href.indexOf('post.php?') != -1) return;
                    Sandbox.storage.remove('mentionsLogins');
                },

                markMessagesAsRead: function(e)
                {
                    var topicId = Helper.getParam('id');

                    if (!topicId) return;

                    Sandbox.transport.io.send('readNotifyInTopic', {
                        topicId: topicId
                    });
                }
            });

        return {
            initialize: function(model)
            {
                return new MentionsView({
                    el: $("#pun-main"),
                    model: model
                })
            }
        }
    }
);

